/**
 * Input Schema of CargaCorreios
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {CargaCorreios} from '@/model/resource/CargaCorreios'
import {CargaCollection} from '@/model/collection/CargaCollection'

/* TODO: review generated schema */
export class InputCargaCorreiosSchema extends Schema {
  collectionCarga = new CargaCollection().noPagination()

  readonly name = 'InputCargaCorreios'

  readonly fieldSet: FieldSet<CargaCorreios> = {
    carga: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionCarga.all(),
      },
    }),
    cdCorreios: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 15,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
